export default __webpack_public_path__ + "static/media/toledo_8.2b12cc4a.png";